import * as React from 'react';
import { AspectRatio } from 'react-aspect-ratio';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const ContentSkeleton: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column">
      <AspectRatio ratio="0.8">
        <Skeleton variant="rounded" sx={{ borderRadius: '10px' }} />
      </AspectRatio>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          paddingTop: 1.5,
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0,
        }}
      >
        <Skeleton variant="circular" sx={{ width: '2rem', height: '2rem', flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="60%" sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="40%" />
        </Box>
      </Box>
    </Box>
  );
};

export default ContentSkeleton;
